import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseStep1Layout, BaseStep1LayoutProps } from "../shared/BaseStep1Layout";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

export type PeerToPeerDonateToPrimaryCampaignStep1LayoutProps = Omit<BaseStep1LayoutProps, "slots"> & {
  slots: {
    banner?: React.ReactNode;
    summary: React.ReactNode;
    coreInfo?: React.ReactNode;
    donationAmounts: React.ReactNode;
    fundDesignation?: React.ReactNode;
    giftAid?: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
    donors?: React.ReactNode;
    divider?: React.ReactNode;
  };
};

export const PeerToPeerDonateToPrimaryCampaignStep1Layout: FC<PeerToPeerDonateToPrimaryCampaignStep1LayoutProps> = ({
  slots,
  isOneColumn,
  isEmbed,
  isSquareBanner,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseStep1Layout
      {...rest}
      isEmbed={isEmbed}
      isOneColumn={isOneColumn}
      isSquareBanner={isSquareBanner}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {slots.summary}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.donors}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={2}>
            {!isSmallScreen && slots.coreInfo}
            {!isSmallScreen && !isEmbed && slots.divider}
            {slots.donationAmounts}
            {slots.fundDesignation}
            {slots.giftAid}
            {(isSmallScreen || isOneColumn || isEmbed) && slots.donors}
            <Stack width="100%" gap={1}>
              {slots.generateReceipt}
              {slots.zeffyBusinessModel}
            </Stack>
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
      }}
    />
  );
};
